import { useTranslation } from 'react-i18next';
import { ScFormTextHeader } from './styled';

export const FormTextHeader = () => {
  const { t } = useTranslation('common');

  return (
    <ScFormTextHeader>
      <h2>{t('auth.registration.title')}</h2>
    </ScFormTextHeader>
  );
};
